/**
 * 下载文件工具函数
 */
export const downloadFile = (url: string, filename: string = "download"): void => {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    anchor.style.display = "none";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };
  
  /**
   * 下载 Blob 文件
   */
  export const downloadBlob = (blob: Blob, filename: string = "download"): void => {
    const url = URL.createObjectURL(blob);
    downloadFile(url, filename);
    URL.revokeObjectURL(url); // 释放内存
  };
  